import { useWebsocketUpdates } from "@finbackoffice/site-core";
import { IClientError, HoursRange, IEventFeedResponse } from "@finbackoffice/websocket-client";
import { useCallback, useMemo, useState } from "react";

interface IEventsState {
    data: IEventFeedResponse[];
    loading: boolean;
}

export const usePrematchTopEvents = (hoursRange: HoursRange) => {
    const [events, setEvents] = useState<IEventsState>({
        data: [],
        loading: true,
    });
    const [isFallback, setIsFallback] = useState(false);

    const onSocketUpdate = useCallback((events: IEventFeedResponse[], error: IClientError) => {
        if (!error) {
            if (events.length) {
                setEvents({
                    data: events,
                    loading: false,
                });
            } else {
                setIsFallback(true);
            }
        } else {
            setEvents((state) => ({
                ...state,
                loading: false,
            }));
        }
    }, []);

    const payload = useMemo(
        () => ({ hours: !isFallback ? hoursRange : HoursRange.FORTY_EIGHT }),
        [hoursRange, isFallback],
    );

    useWebsocketUpdates("top", onSocketUpdate, undefined, payload);

    return { events, setEvents };
};
